/**
 * @typedef {import('./lib/create-h.js').Child} Child
 * @typedef {import('./lib/create-h.js').Properties} Properties
 * @typedef {import('./lib/create-h.js').Result} Result
 */

export {h, s} from './lib/index.js'
